import React from 'react';
import { Card, Space, Typography } from 'antd';
import ContrastTag from './ContrastTag';

const { Title, Text } = Typography;

/**
 * Тестовый компонент для проверки контрастности цветов
 */
const ColorTest = () => {
  const testColors = [
    { name: 'Белый', hex: '#ffffff' },
    { name: 'Желтый', hex: '#ffff00' },
    { name: 'Светло-желтый', hex: '#ffff99' },
    { name: 'Красный', hex: '#ff0000' },
    { name: 'Зеленый', hex: '#00ff00' },
    { name: 'Синий', hex: '#0000ff' },
    { name: 'Черный', hex: '#000000' },
    { name: 'Серый', hex: '#808080' },
    { name: 'Светло-серый', hex: '#cccccc' },
    { name: 'Темно-серый', hex: '#404040' },
    { name: 'Розовый', hex: '#ffc0cb' },
    { name: 'Фиолетовый', hex: '#800080' },
    { name: 'Оранжевый', hex: '#ffa500' },
    { name: 'Бирюзовый', hex: '#40e0d0' }
  ];

  return (
    <Card title="Тест контрастности цветов" style={{ margin: '20px' }}>
      <Title level={4}>Проверка видимости текста на различных цветах фона</Title>
      <Text type="secondary">
        Светлые цвета теперь имеют темный текст + тонкую черную рамку + тень для элегантной видимости
      </Text>
      
      <div style={{ marginTop: '20px' }}>
        <Space wrap>
          {testColors.map((color) => (
            <div key={color.hex} style={{ textAlign: 'center' }}>
              <ContrastTag backgroundColor={color.hex}>
                {color.name}
              </ContrastTag>
              <div style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>
                {color.hex}
              </div>
            </div>
          ))}
        </Space>
      </div>

      {/* Дополнительный тест для светлых цветов */}
      <div style={{ marginTop: '30px' }}>
        <Title level={5}>Особое внимание к светлым цветам:</Title>
        <Space wrap>
          {['#ffffff', '#ffff00', '#ffff99', '#cccccc'].map((color) => (
            <div key={color} style={{ textAlign: 'center', marginRight: '20px' }}>
              <ContrastTag backgroundColor={color}>
                {color === '#ffffff' ? 'Белый' : 
                 color === '#ffff00' ? 'Желтый' :
                 color === '#ffff99' ? 'Светло-желтый' : 'Светло-серый'}
              </ContrastTag>
              <div style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>
                Тонкая рамка (1px) + тень
              </div>
            </div>
          ))}
        </Space>
      </div>
      
      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
        <Title level={5}>Объяснение:</Title>
        <ul style={{ marginBottom: 0 }}>
          <li>Светлые цвета (белый, желтый, светло-серый) теперь имеют <strong>темный текст</strong></li>
          <li>Для светлых цветов добавлена <strong>тонкая черная рамка (1px)</strong> для элегантного выделения</li>
          <li>Дополнительно добавлена <strong>тень</strong> для светлых тегов</li>
          <li>Темные цвета (черный, синий, красный) имеют <strong>белый текст</strong></li>
          <li>Контрастность вычисляется по формуле W3C для лучшей читаемости</li>
        </ul>
      </div>
    </Card>
  );
};

export default ColorTest;
